export default __webpack_public_path__ + "static/media/Grossmutter-beim-Kiosk.c5c05b8d.webp";